<template src="./html/Items.html"></template>

<script>
	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				modal: {
					selector: 'recurring-items',
				},

				recurring: null,
				items: null,
			}
		},
		watch: {
			'recurring.auto_send'() {
				this.update()
			}
		},
		mounted() {
			var modal = $('#'+this.modal.selector)
			var that = this
		},
		methods: {
			open(recurring) {
				this.recurring = recurring
				this.getData()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			getData() {
				this.items = null
				this.$http.get('admin/recurrings/' + this.recurring.id + '/items')
				.then(response => {
					this.items = response.body
				})
			},
			update() {
				var input = $('#input-auto-send')
				input.addClass('disabled')
				this.$http.put('admin/recurrings/' + this.recurring.id, this.recurring)
				.then(response => {
					input.removeClass('disabled')
				}).catch(function(response) {
					console.log(response)
					input.removeClass('disabled')
				})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/agreements/components/recurrings/views/Items.vue